
import JoinCommunityCta from '~/components/community/JoinCommunityCta.vue';
import NewsletterSignupInput from '~/components/generic/NewsletterSignupInput.vue';
import BlogIntro from '~/components/page-components/blogpage/BlogIntro.vue';
import BlogPostList from '~/components/page-components/blogpage/BlogPostList.vue';
export default {
  components: { BlogIntro, BlogPostList, JoinCommunityCta, NewsletterSignupInput },
  mounted () {
    this.$store.commit('closeMenu');
  }

};
